import { DELIVERY_OPTIONS, formatMoney, GRINDS, labelOf, type Order, WEIGHTS } from '@c214/shared';
import { useCart } from '../../providers';
import { Button } from '../ui/button';
import { OrderStatusDot } from './OrderStatusDot';
import { PaymentStatusBadge } from './PaymentStatusBadge';

export function OrderCard({ order }: { order: Order }) {
  const cart = useCart();

  const repeat = () => {
    for (const item of order.items) {
      cart.add({
        productId: item.productId,
        name: item.name,
        weight: item.weight,
        grind: item.grind,
        unitPrice: item.unitPrice,
        qty: item.qty,
      });
    }
  };

  return (
    <div className="mb-6 border border-line">
      <div className="flex flex-wrap items-center justify-between gap-3 border-b border-line-soft px-6 py-4">
        <span className="font-mono text-[13px] font-bold text-ink">№{order.number}</span>
        <span className="mono-label">{new Date(order.createdAt).toLocaleDateString('uk-UA')}</span>
        <OrderStatusDot status={order.status} />
      </div>

      <div className="divide-y divide-line-soft">
        {order.items.map((item, index) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: OrderItem has no own id, and the same productId can repeat with a different weight/grind, so index disambiguates
          <div key={`${item.productId}-${index}`} className="flex items-center gap-4 px-6 py-4">
            <div className="flex-1">
              <p className="text-[15px] font-semibold text-ink">{item.name}</p>
              <p className="mono-label mt-1">
                {labelOf(WEIGHTS, item.weight)} · {labelOf(GRINDS, item.grind)} × {item.qty}
              </p>
            </div>
            <span className="text-[15px] font-bold text-ink">
              {formatMoney(item.unitPrice * item.qty)}
            </span>
          </div>
        ))}
      </div>

      <div className="flex flex-wrap items-center justify-between gap-3 border-t border-line-soft px-6 py-4">
        <div className="flex flex-col gap-1">
          <span className="text-[13px] text-muted">
            {labelOf(DELIVERY_OPTIONS, order.deliveryKey)}
          </span>
          {order.ttn && (
            <span className="font-mono text-[11px] uppercase tracking-[0.12em] text-muted">
              ТТН: {order.ttn}
            </span>
          )}
          <PaymentStatusBadge paymentStatus={order.paymentStatus} />
        </div>
        <div className="flex items-center gap-4">
          <span className="text-[18px] font-bold text-ink">{formatMoney(order.total)}</span>
          <Button variant="secondary" size="sm" onClick={repeat}>
            ПОВТОРИТИ
          </Button>
        </div>
      </div>
    </div>
  );
}
